import { onToggleVisibilityClick } from './on_toggle_visibility_click';
import { onBackClick } from './on_back_click';

export const initialize = ($nav, $body, setCurrentNavLabel) => {
    $nav.find('.navigation-control--toggle-visibility')
        .on('click', onToggleVisibilityClick($nav, $body, setCurrentNavLabel));

    $nav.find('.navigation-control--back')
        .on('click', onBackClick($nav, setCurrentNavLabel));
};
